import { render } from "./Lang.vue?vue&type=template&id=19b63e03&scoped=true&ts=true"
import script from "./Lang.vue?vue&type=script&lang=ts"
export * from "./Lang.vue?vue&type=script&lang=ts"

import "./Lang.vue?vue&type=style&index=0&id=19b63e03&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b63e03"]])

export default __exports__